import { Link } from 'react-router-dom';

export default function BenefitsGrid() {
  const items = [
    {
      icon: 'ri-search-eye-line',
      title: 'Instant Product Search',
      description: 'Find exactly what you need across 14 curated categories without endless scrolling or manual browsing.',
      link: '/article/how-to-use-vigorbuy-spreadsheet',
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Trusted Seller Compare',
      description: 'Compare prices and seller ratings side by side to make confident purchasing decisions every time.',
      link: '/article/vigorbuy-seller-verification-tips',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Safe Buying Guides',
      description: 'Follow step-by-step guides covering quality inspection, shipping protection, and seller verification.',
      link: '/article/is-vigorbuy-safe-review',
    },
  ];

  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 border border-primary-200 rounded-full whitespace-nowrap">
              Why VigorBuy?
            </span>
            <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              Faster Discovery.
              <br />
              Better Buys.
            </h2>
            <p className="mt-4 text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
              Compare sellers, inspect quality, and ship smarter &mdash; everything in one curated place.
            </p>
          </div>

          {/* Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {items.map((item) => (
              <div
                key={item.title}
                className="group bg-background-100 rounded-xl p-6 md:p-8 hover:bg-primary-500 transition-all duration-300 cursor-default"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-background-50 rounded-lg group-hover:bg-background-50/20 transition-colors duration-300">
                  <i className={`${item.icon} text-2xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
                </div>
                <h3 className="mt-5 text-lg font-semibold text-foreground-950 group-hover:text-background-50 transition-colors duration-300">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 group-hover:text-background-50/85 transition-colors duration-300 leading-relaxed">
                  {item.description}
                </p>
                <Link
                  to={item.link}
                  className="inline-flex items-center gap-1 mt-4 text-sm font-medium text-primary-600 group-hover:text-background-50 transition-colors duration-300 whitespace-nowrap"
                >
                  Learn more <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}